import { useCallback, useContext } from 'react'

import noop from 'lib/function/noop'
import ModalContext from 'contexts/ModalContext'
import PendingLoginModalContext from 'contexts/PendingLoginModalContext'
import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import type { AccountAccessModalResult } from 'components/Account/AccountAccess/AccountAccessModal.types'
import { useAppSelector } from './reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'

export default function usePendingLoginHandler(
  onLogin: () => void,
  mode?: App.UiAccountModalMode,
  onShowLogin: () => void = noop,
  onDismissLogin: () => void = noop,
) {
  const showModal = useContext(ModalContext)
  const loginModalHandlers = useContext(PendingLoginModalContext)
  const showLoginModal = mode ? loginModalHandlers[mode] : undefined
  const loggedIn = useAppSelector(selectLoggedIn)

  return useCallback(async() => {
    if (!loggedIn) {
      onShowLogin()
      const result = showLoginModal
        ? await showLoginModal()
        : await showModal<AccountAccessModalResult>(<AccountAccessModal initialMode={mode} />)

      if (result.loggedIn) {
        onLogin()
      } else {
        onDismissLogin()
      }
    } else {
      onLogin()
    }
  }, [loggedIn, mode, onDismissLogin, onLogin, onShowLogin, showLoginModal, showModal])
}
